export default __webpack_public_path__ + "static/media/landing-perspective-photo.344bb6aa.png";